module.exports = __webpack_public_path__ + "img/8.37074912.jpg";